<template>
  <div class="default-page">
    <div class="d-flex justify-content-between">
      <div>
        <!-- To android/ios platform -->
        <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasAvatar" aria-labelledby="offcanvasAvatarLabel">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasAvatarLabel">Что хотите сделать?</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" id="btn-close-photo-selector"></button>
          </div>
          <div class="offcanvas-body pt-0">
            <button type="button" @click="user_takePhoto()" class="btn btn-primary w-100 mb-3 rounded-pill">Открыть камеру</button>
            <button type="button" @click="user_selectPhoto()" class="btn btn-primary w-100 mb-3 rounded-pill">Выбрать из галереи</button>
          </div>
        </div>
        <!-- /To android/ios platform -->
        <!-- To web platform -->
        <div class="d-none">
          <input type="file" @change="user_attachFile($event, user, this)" :id="`append-file-avatar`" accept="capture=camera,image/*" />
        </div>
        <!-- /To web platform -->
      </div>
    </div>

    <form @submit.prevent="saveUser">
      <div class="text-center mb-4">
        <div class="user-avatar-wrapper">
          <img v-if="['android', 'ios'].includes(PLATFORM)" class="user-avatar" id="user-avatar" :src="userAvatarFullPath" data-bs-toggle="offcanvas" data-bs-target="#offcanvasAvatar" aria-controls="offcanvasAvatar" alt="Avatar" />
          <img v-else class="user-avatar" id="user-avatar" :src="userAvatarFullPath" @click="user_attachFileDialog()" alt="Avatar" />
        </div>
        <p class="text-center">{{ user.full_name }}</p>
      </div>
      <div class="mb-3">
        <label class="form-label">Фамилия</label>
        <input type="text" class="form-control" v-model="user.surname">
      </div>
      <div class="mb-3">
        <label class="form-label">Имя</label>
        <input type="text" class="form-control" v-model="user.first_name">
      </div>
      <div class="mb-3">
        <label class="form-label">Отчество</label>
        <input type="text" class="form-control" v-model="user.patronymic">
      </div>
      <div class="mb-3">
        <label class="form-label">Пол</label>
        <select name="gender" class="form-control" v-model="user.gender">
          <option value="0">Не указан</option>
          <option value="1">Мужской</option>
          <option value="2">Женский</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Логин</label>
        <input type="text" class="form-control" :value="user.login" readonly>
      </div>
      <div class="mb-3">
        <div v-if="!changePassword">
          <label class="form-label">Пароль</label>
          <div>
            <button @click="changePassword = !changePassword" class="btn btn-secondary btn-min-width rounded-pill"><i class="bi bi-lock-fill me-3"></i>Изменить</button>
          </div>
        </div>
        <div v-else>
          <div class="mb-3">
            <label class="form-label">Введите новый пароль</label>
            <div class="input-group mb-3">
              <input type="password" class="form-control" v-model="user.new_password" aria-label="Новый пароль" aria-describedby="button-addon-new-password">
              <button @click="changePassword = !changePassword" type="button" id="button-addon-new-password" class="btn btn-secondary"><i class="bi bi-x"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label">Номер телефона</label>
        <input type="text" class="form-control" v-model="user.phone" v-mask="['+# (###) ###-####']">
      </div>
      <div class="mb-4">
        <label class="form-label">Должность</label>
        <input type="text" class="form-control" v-model="user.job_title">
      </div>
      <div class="text-center pt-2 mb-3">
        <button type="submit" class="btn btn-lg btn-primary btn-min-width rounded-pill">Сохранить</button>
      </div>
    </form>
  </div>
</template>

<script>
import EnvConfig from "@/env";
import { UserModel } from "@/models/UserModel";
import { mask } from 'vue-the-mask'
import { takePhoto, selectPhoto } from "@/helpers/camera";
import getImageByModel from "@/mixins/getImageByModel";

export default {
  name: 'SettingsPage',
  directives: { mask },
  mixins: [
      getImageByModel
  ],
  data() {
    return {
      user: UserModel.current(),
      changePassword: false,
      DEF_IMAGE: '/img/default_150x150.png',
      PLATFORM: EnvConfig.PLATFORM,
    }
  },
  computed: {
    userAvatarFullPath() {
      return this.getImageByModel(this.user, 'user-avatar');
    }
  },
  methods: {
    saveUser() {
      this.user.flush();
    },
    user_takePhoto() {
      takePhoto(image => {
        const img = document.getElementById(`user-avatar`);
        img.src = this.user.avatar = `${image}`;
        img.style.display = 'block';
      });
      this.closeSelectPhotoPopup();
    },
    user_selectPhoto() {
      selectPhoto(image => {
        const img = document.getElementById(`user-avatar`);
        img.src = this.user.avatar = `${image}`;
        img.style.display = 'block';
      });
      this.closeSelectPhotoPopup();
    },
    closeSelectPhotoPopup() {
      document.getElementById(`user-avatar`).click();
    },
    user_attachFileDialog() {
      const inputFile = document.getElementById(`append-file-avatar`);
      inputFile.click();
    },
    async user_attachFile(event, model) {
      const getBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };
      const file = event.target.files.length ? event.target.files[0] : null;
      if (!file) {
        return;
      }

      try {
        model.avatar = await getBase64(file);
      } catch (e) {
        console.error('Error uploading file', e);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.user-avatar-wrapper {
  margin: 30px auto 15px auto;
  width: 150px;
  height: 150px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;

  .user-avatar {
    max-width: 100%;
  }
}
</style>